import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockGroupMembersResponse } from '@percent/admin-dashboard/fixtures/api/groups/mockGroupMembers'
import { mockGroupsResponse } from '@percent/admin-dashboard/fixtures/api/groups/mockGroups'

export const groupsHandlers = [
  rest.get(`${config.urls.api}v1/groups`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockGroupsResponse))
  }),
  rest.get(`${config.urls.api}v1/groups/:groupId/members`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockGroupMembersResponse))
  }),
  rest.post(`${config.urls.api}v1/groups/:groupId/members`, async (_, res, ctx) => {
    return res(ctx.status(201), ctx.json({ object: 'group_member', data: [] }))
  }),
  rest.put(`${config.urls.api}v1/groups/:groupId/members/:memberId`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ object: 'group_member', data: {} }))
  })
]
